// Client for the map-boundary API (/api/geo).
//
// Choropleth shapes are generated, not shipped — see
// backend/app/services/geo_boundaries.py. These calls report what this
// instance has stored and download a country on demand. Downloading is
// idempotent: a stored country returns `present` without touching the network.

import api from './client'

export interface GeoCountry {
  code: string
  name: string
  /** Only on `stored` entries. */
  size?: number
  updated?: number
  /** Only on `available` entries. */
  present?: boolean
}

export interface GeoJob {
  country: string
  status: 'running' | 'done' | 'error' | 'present' | 'absent'
  error?: string | null
  messages?: string[]
  features?: number
  size?: number
}

export interface GeoStatus {
  geo_dir: string
  world: boolean
  index: boolean
  country_aliases: number
  state_aliases: number
  stored: GeoCountry[]
  stored_codes: string[]
  available: GeoCountry[]
  can_build: boolean
  source_cached: boolean
  jobs: Record<string, GeoJob>
}

export async function fetchGeoStatus(): Promise<GeoStatus> {
  const res = await api.get('/geo/status')
  return res.data as GeoStatus
}

/** Start (or join) a download. `country` is an ISO A2 code or 'world'. */
export async function downloadGeoCountry(country: string, force = false): Promise<GeoJob> {
  const res = await api.post('/geo/download', { country, force })
  return res.data as GeoJob
}

export async function fetchGeoJob(country: string): Promise<GeoJob> {
  const res = await api.get(`/geo/download/${encodeURIComponent(country)}`)
  return res.data as GeoJob
}
